module.exports = __webpack_public_path__ + "img/microsoft-security-update-breaks-vpn.a7bf32a9.webp";